/*
 * Author: harper
 * File Created: Wednesday, 24-07-03 03:41 pm
 * Last Modified: Tuesday, 25-07-15 11:39 am, by Dw
 */

import Add from './Add';
import AddToHomeScreen from './AddToHomeScreen';
import ArrowBack from './ArrowBack';
import ArrowDropDown from './ArrowDropDown';
import ArrowForward from './ArrowForward';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import Bill from './Bill';
import Bonus from './Bonus';
import Calendar from './Calendar';
import Card from './Card';
import CheckBoxChecked from './CheckBoxChecked';
import CheckBoxSquareChecked from './CheckBoxSquareChecked';
import CheckBoxUnChecked from './CheckBoxUnChecked';
import CheckBoxSquareUnChecked from './CheckBoxUnCheckedSquare';
import CheckCircleIcon from './CheckCircleIcon';
import CheckedCircleFill from './CheckedCircleFill';
import Close from './Close';
import Coin from './Coin';
import Contact from './Contact';
import Copy from './Copy';
import Copy2 from './Copy2';
import Deposit from './Deposit';
import Download from './Download';
import DownloadAndroidAPK from './DownloadAndroidAPK';
import DownloadAndroidBadge from './DownloadAndroidBadge';
import DownloadIOSBadge from './DownloadIOSBadge';
import DvaultExpanded from './DvaultExpanded';
import DvaultUnExpanded from './DvaultUnExpanded';
import Earth from './Earth';
import Edit from './Edit';
import Eye from './Eye';
import EyeClose from './EyeClose';
import FilledClose from './FilledClose';
import FilledMore from './FilledMore';
import FilledPlus from './FilledPlus';
import FomoPay from './FomoPay';
import Forbidden from './Forbidden';
import Frozen from './Frozen';
import Gift from './Gift';
import Gift2 from './Gift2';
import HeaderMenuBtn from './HeaderMenuBtn';
import Help from './Help';
import HollowInfo from './HollowInfo';
import ImgPlaceholder from './ImgPlaceholder';
import Info from './Info';
import Invite from './Invite';
import Mining from './Mining';
import Notice from './Notice';
import Photo from './Photo';
import Plus from './Plus';
import Point from './Point';
import Refund from './Refund';
import Scan from './Scan';
import Security from './Security';
import Selected from './Selected';
import {
  ShareAppsLine,
  ShareAppsTelegram,
  ShareAppsTwitter,
  ShareAppsWechat,
  ShareAppsWhatsapp,
} from './ShareApps';
import Switch from './Switch';
import TransHistory from './TransHistory';
import User from './User';
import Verified from './Verified';
import Wallet from './Wallet';
import Withdraw from './Withdraw';

export const svgs = {
  Photo,
  Add,
  ArrowDropDown,
  ArrowForward,
  ArrowRight,
  ArrowLeft,
  Close,
  CheckBoxChecked,
  CheckBoxUnChecked,
  Calendar,
  Wallet,
  User,
  Card,
  FilledClose,
  Eye,
  EyeClose,
  Coin,
  CheckCircleIcon,
  HeaderMenuBtn,
  Refund,
  Earth,
  Contact,
  Selected,
  Point,
  Security,
  Switch,
  Verified,
  Deposit,
  TransHistory,
  Withdraw,
  ArrowBack,
  Copy,
  Copy2,
  FilledPlus,
  FilledMore,
  Info,
  Scan,
  Help,
  AddToHomeScreen,
  Mining,
  Gift,
  Gift2,
  HollowInfo,
  Edit,
  Plus,
  Bill,
  Notice,
  Forbidden,
  Frozen,
  Invite,
  CheckBoxSquareChecked,
  CheckBoxSquareUnChecked,
  ImgPlaceholder,
  DvaultUnExpanded,
  DvaultExpanded,
  FomoPay,
  DownloadAndroidBadge,
  DownloadIOSBadge,
  DownloadAndroidAPK,
  Bonus,
  CheckedCircleFill,
  Download,
  ShareAppsLine,
  ShareAppsTelegram,
  ShareAppsWechat,
  ShareAppsTwitter,
  ShareAppsWhatsapp,
};

export type IconType = keyof typeof svgs;
